import { useSyncExternalStore } from "react";
import type { Line } from "../person/arrivals.ts";

type Heard = { for: string; lines: readonly Line[] };

let heard: Heard = { for: "", lines: [] };
const listeners = new Set<() => void>();

export function nowHeard(conversation: string, lines: readonly Line[]): void {
  if (heard.for === conversation && heard.lines === lines) return;
  heard = { for: conversation, lines };
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useHeard(conversation: string): readonly Line[] {
  const now = useSyncExternalStore(
    subscribe,
    () => heard,
    () => heard,
  );
  return now.for === conversation ? now.lines : [];
}
